

<template>
    <svg :width="`${width}px`" :height="`${height}px`" viewBox="0 0 150 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Photo-Upload---1" transform="translate(-649.000000, -608.000000)">
                <g id="Group-6" transform="translate(550.000000, 608.000000)">
                    <g id="Upload-Icon" transform="translate(99.000000, 0.000000)">
                        <circle id="Oval" fill="#E75300" cx="75" cy="75" r="75"></circle>
                        <g id="Group-4" transform="translate(50.000000, 38.000000)" fill="#FFFFFF">
                            <g id="Group" transform="translate(0.991667, 0.000000)">
                                <g id="Group-3">
                                    <g id="Group-2">
                                        <polygon id="Path-6" points="0 30.4615385 24.65 0 49.3 30.4615385"></polygon>
                                    </g>
                                </g>
                            </g>
                            <rect id="Rectangle" x="19.6916667" y="27.0769231" width="11.9" height="18.6153846"></rect>
                            <polygon id="Rectangle-Copy" transform="translate(24.791667, 60.923077) rotate(-270.000000) translate(-24.791667, -60.923077) " points="19.7147436 36.2730769 29.8685897 36.2730769 29.8685897 85.5730769 19.7147436 85.5730769"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconUpload",
    props: {
        width: {
            type: Number,
            default: 150
        },
        height: {
            type: Number,
            default: 150
        }
    }
};
</script>

